import React, { useEffect, useRef } from 'react';
import { ReporteProvider, useReporte, reporteActions } from '../../context/ReporteContext';
import FormularioReporteCompleto from '../../components/reportes/FormularioReporteCompleto';

// Componente interno que usa el contexto
const CrearReporteContent: React.FC = () => {
  const { dispatch, reporte } = useReporte();
  const inicializadoRef = useRef(false);

  // Inicializar reporte al cargar SOLO UNA VEZ
  useEffect(() => {
    // Solo inicializar si no se ha inicializado antes y no hay ID temporal
    if (!inicializadoRef.current && !reporte.id_temporal) {
      // 🏢 MULTITENANT: NO pasar empresa_id - se obtiene dinámicamente del contexto
      dispatch(reporteActions.inicializar({}));
      inicializadoRef.current = true;

    }
  }, []); // Array vacío - solo al montar

  return <FormularioReporteCompleto />;
};

// Componente principal con Provider
const CrearReporteView: React.FC = () => {
  return (
    <ReporteProvider>
      <CrearReporteContent />
    </ReporteProvider>
  );
};

export default CrearReporteView;